import React, { createContext, useState, useEffect } from 'react';

export const PrivacyContext = createContext();

export const PrivacyProvider = ({ children }) => {
  const [cookieConsent, setCookieConsent] = useState(false);

  useEffect(() => {
    // Check if the user has already consented in a previous session
    const consent = localStorage.getItem('cookie_consent_accepted');
    if (consent === 'true') {
      setCookieConsent(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookie_consent_accepted', 'true');
    setCookieConsent(true);
  };

  return (
    <PrivacyContext.Provider value={{ cookieConsent, acceptCookies }}>
      {children}
    </PrivacyContext.Provider>
  );
};